export default () => ({
    config: {},
    cachedConfig: null,
});
